// src/firestore/users/index.ts
import { firestore } from '../../helpers/firebase/firestore'
import * as path from '../path'

/**
 * The path to the collection containing user documents.
 *
 * `users`
 */
export function collectionPath(): string {
  return 'users'
}

/**
 * The path to a specific user document.
 *
 * `users/{userId}`
 */
export function documentPath(userId: string): string {
  return path.append(collectionPath(), userId)
}

/**
 * A Firestore document representing a user.
 */
export type User = {
  /** Unique identifier for the user (same as docId) */
  userId: string
  /** User's display name */
  displayName: string
  /** Total amount of CARD tokens the user has */
  tokenBalance: number
  /** Timestamp when the user was created */
  createdAt: firestore.Timestamp
  /** Timestamp when the user was last updated */
  lastUpdatedAt: firestore.Timestamp
  /** For tutorial and free card pack purpose */
  firstTimeUser: boolean
  /** The referrer's id */
  referredBy?: string
}
